import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl, useSelector } from '@grandvisionhq/state';
import { useDeliveryIndicator } from '../../../contexts/DeliveryIndicator/context.js';
import { useGetDeliveryEstimationMessage } from '../../../hooks/use-get-delivery-estimation-message.js';
import '@grandvisionhq/graphql';
import '../../../operations/queries/get-delivery-estimation.js';
import '../../../operations/queries/get-estimated-delivery-by-skus.js';
import '../../../operations/queries/get-shipping-methods-for-cart.js';
import '../../../state/actions.js';
import { getPreferredShippingMethod } from '../../../state/selectors.js';
import { DeliveryIndicator } from '../components/DeliveryIndicator.js';
import '@grandvisionhq/common';
import { DeliveryIndicatorTooltip } from '../components/DeliveryIndicatorTooltip.js';
import '@grandvisionhq/elements';
import '@grandvisionhq/iris-ui';
import { DeliveryIndicatorModalContainer } from './DeliveryIndicatorModal.js';

var DeliveryIndicatorFullDateContainer = (_param)=>{
    var { items =[] , fallbackLabel , view ='full' , withRxLens  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "items",
        "fallbackLabel",
        "view",
        "withRxLens"
    ]);
    const { getLabel  } = useIntl();
    const { deliveryInfo  } = useDeliveryIndicator();
    const preferredShippingMethod = useSelector(getPreferredShippingMethod);
    const { deliveryMessage , loading , error  } = useGetDeliveryEstimationMessage(items, preferredShippingMethod, withRxLens);
    const tooltipSlot = deliveryInfo ? /*#__PURE__*/ React.createElement(DeliveryIndicatorModalContainer, null) : /*#__PURE__*/ React.createElement(DeliveryIndicatorTooltip, {
        message: getLabel('products.deliveryIndicator.deliveryTooltip'),
        view: view
    });
    return /*#__PURE__*/ React.createElement(DeliveryIndicator, swcHelpers.extends({
        deliveryMessage: deliveryMessage,
        loading: loading,
        error: !!error,
        view: view,
        fallbackLabel: fallbackLabel,
        tooltipSlot: tooltipSlot
    }, rest));
};

export { DeliveryIndicatorFullDateContainer };
//# sourceMappingURL=DeliveryIndicatorFullDate.js.map
